import * as React from "react";
import * as PrismReactRenderer from "prism-react-renderer";
import type { Key } from "react";

const Highlight = PrismReactRenderer.Highlight;
const github = PrismReactRenderer.themes.github;

interface Props {
  data: any;
  language: "json" | "markup";
  formatter?: (data: any) => any;
}
export const HighlightedText: React.FC<Props> = ({ data, language, formatter = (v) => v }) => {
  return (
    <Highlight code={formatter(data)} language={language} theme={github}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre
          className={className}
          style={{
            ...style,
            width: "100%",
            padding: "10px 20px",
          }}
        >
          {tokens.map((line, i) => {
            const lineProps: PrismReactRenderer.LineOutputProps = getLineProps({ line, key: i });
            const { key: rawLineKey, ...restLineProps } = lineProps;
            const lineKey: Key | any = rawLineKey ?? `line-${i}`;

            return (
              <div key={lineKey} {...restLineProps}>
                {line.map((token, key) => {
                  const tokenProps: PrismReactRenderer.LineOutputProps = getTokenProps({ token, key });
                  const { key: rawTokenKey, className: tokenClassName, ...restTokenProps } = tokenProps;
                  const tokenKey: Key | any = rawTokenKey ?? `token-${i}-${key}`;

                  return <span key={tokenKey} {...restTokenProps} className={`${tokenClassName || ""} input-mono`} />;
                })}
              </div>
            );
          })}
        </pre>
      )}
    </Highlight>
  );
};
